import {Translation} from '@/i18n/locales/type.ts';

const th: Translation = {
  home: {
    firstVisit: '	มาครั้งแรกโดยไม่มีการจอง',
    returningVisitor: 'กรุณากรอกเบอร์โทรศัพท์หรืออีเมล',
    error_message: {
      invalid_token: 'การเชื่อมต่อเครือข่ายไม่เสถียร',
      search: 'เกิดข้อผิดพลาดระหว่างการค้นหา',
      checkin:
        'เกิดข้อผิดพลาดระหว่างการเช็คอิน หากยังคงมีปัญหา กรุณาติดต่อเคาน์เตอร์บริการ',
    },
    dialog_message: {
      reservation: {
        checked_in: 'ยืนยันการจองของคุณแล้ว การเช็คอินเสร็จสมบูรณ์',
        no_customer:
          'ไม่พบข้อมูลลูกค้า\nกรุณาตรวจสอบหมายเลขโทรศัพท์หรืออีเมลอีกครั้ง',
      },
      walkin: {
        checked_in:
          'การเช็คอินเสร็จสมบูรณ์ กรุณารอสักครู่ เราจะให้บริการตามลำดับ',
        no_customer_title: 'ไม่พบข้อมูลของคุณ',
        no_customer_description: 'นี่เป็นการมาใช้บริการครั้งแรกใช่ไหม?',
        start_first_visit: 'เริ่มลงทะเบียนครั้งแรก',
        no_booking_title: 'คุณ{{name}} เราจะช่วยลงทะเบียนคิววันนี้ให้คุณ',
        no_booking_description:
          'เราสามารถช่วยลงทะเบียนคิววันนี้ให้คุณได้\nอาจมีเวลารอหรือข้อจำกัดสำหรับหัตถการบางรายการตามสถานการณ์ในวันนั้น',
        start_checkin: 'เช็คอิน',
      },
      no_booking: {
        title: 'ไม่พบข้อมูลการจอง',
        description:
          'เราดำเนินการแบบจองล่วงหน้าเพื่อให้มั่นใจในการดูแลอย่างใส่ใจและเวลาปรึกษาที่เพียงพอ\nหากคุณได้ทำการจองแล้ว กรุณาสอบถามที่เคาน์เตอร์บริการ',
      },
      invalid_building: {
        title:
          'ข้อมูลโรงพยาบาลไม่ถูกต้อง หากโรงพยาบาลที่คุณต้องการเช็คอินไม่ใช่ "โซล กังนัม มิวส์คลินิก อาคารหลัก ชั้น 2" กรุณาติดต่อเคาน์เตอร์เพื่อขอที่อยู่เว็บไซต์เช็คอินที่ถูกต้อง',
      },
      common: {
        confirm: 'ยืนยัน',
        cancel: 'ยกเลิก',
      },
      confirm: {
        title: 'สวัสดีค่ะ คุณ{{name}}',
        description: 'คุณต้องการลงทะเบียนตอนนี้เลยหรือไม่?',
        confirm: 'ใช่ ต้องการลงทะเบียน',
        cancel: 'ไม่',
      },
    },
    form: {
      title: {
        name: 'ชื่อผู้จอง',
        phone: 'หมายเลขโทรศัพท์',
        email: 'อีเมล',
      },
      placeholder: {
        name: 'กรอกชื่อของคุณ',
        phone: 'กรอกหมายเลขโทรศัพท์ของคุณ',
        email: 'กรอกอีเมลของคุณ',
      },
      description:
        'กรุณากรอกอย่างน้อยหนึ่งรายการระหว่างหมายเลขโทรศัพท์หรืออีเมล',
      button: {
        title: 'เช็คอิน',
        loading: 'กำลังค้นหา...',
      },
      birth: {
        title: 'กรุณากรอกวันเกิดเพื่อยืนยันข้อมูลของคุณ',
        year: 'ปี',
        month: 'เดือน',
        day: 'วัน',
      },
    },
    customer_info: {
      title: 'ข้อมูลลูกค้า',
      name: 'ชื่อ',
      phone: 'หมายเลขโทรศัพท์',
      email: 'อีเมล',
      button_title: 'ดำเนินการเช็คอิน',
    },
    language_select: {
      button_title: '🌐 เปลี่ยนภาษา / Language',
    },
  },
  common: {
    or: 'หรือ',
  },
  createChart: {
    title: 'ลงทะเบียนชาร์ตใหม่',
    error_message: {
      invalid_form: 'กรุณากรอกข้อมูลทั้งหมด',
      checkin: 'เกิดข้อผิดพลาดระหว่างกระบวนการเช็คอิน',
    },
    dialog_message: {
      complete: {
        title:
          'การสร้างชาร์ตและการเช็คอินเสร็จสมบูรณ์แล้ว\nลูกค้าที่เข้ามาโดยไม่ได้นัดหมายอาจต้องรอสักครู่ ขอบคุณสำหรับความอดทน',
        button_title: 'ยืนยัน',
      },
    },
    form: {
      name: {
        title: 'ชื่อผู้จอง',
        placeholder: 'กรุณากรอกชื่อของคุณ',
        passport_notice:
          'เพื่อให้การจองถูกต้องและบริการเป็นไปอย่างราบรื่น ขอความกรุณาลูกค้าที่ไม่ได้ถือสัญชาติเกาหลี โปรดกรอกชื่อภาษาอังกฤษตามที่ระบุในหนังสือเดินทางของท่าน',
      },
      phone: {
        title: 'หมายเลขโทรศัพท์',
        placeholder: 'กรุณากรอกหมายเลขโทรศัพท์ของคุณ',
      },
      email: {
        title: 'อีเมล',
        placeholder: 'กรุณากรอกอีเมลของคุณ',
      },
      birth: {
        title: 'วันเกิด',
        year: 'ปี',
        month: 'เดือน',
        day: 'วัน',
      },
      gender: {
        title: 'เพศ',
        male: 'ชาย',
        female: 'หญิง',
      },
      button: {
        title: 'สร้างชาร์ตและเช็คอิน',
        loading: 'กำลังสร้างชาร์ต...',
      },
    },
  },
};

export default th;
